//module for processing upgrades when customer is already logged in to Promana
var AuthUpsell = function(){ 

    var _init = function(){
        
        // $('#plan-type').change(function(){
        //     var plan = $(this).is(':checked')?'PROFESSIONAL':'CREATOR';
        //     $('#plan-cta').fadeTo(500, 0, function() {
        //         $(this).text(ecomConf.trans.recommendation[plan]).fadeTo(500, 1);
        //     });
        // });

        // $('.plan-params').parent().css('min-width','130px');

        // $('.plan-params').change(function(){
        //     var plan = $('#plan-type').is(':checked')?'PROFESSIONAL':'CREATOR';
        //     var freq = $('#pay-freq').is(':checked')?'yr':'mth';
        //     $('.freq p').removeClass('d-none');
        //     $('.freq p:not(.'+plan.toLowerCase()+')').addClass('d-none');
        //     $('.benefit:not(.'+plan.toLowerCase()+'-'+freq+')').hide('slow');
        //     $('.benefit.'+plan.toLowerCase()+'-'+freq).show('slow');
        //     if( freq == 'yr' ){
        //         $('#pay-mth').addClass('d-none');
        //         $('#pay-yr').removeClass('d-none');
        //     }else{
        //         $('#pay-mth').removeClass('d-none');
        //         $('#pay-yr').addClass('d-none');
        //     }
        //     if($('.card-details').hasClass('d-none')){
        //         Do.Ajax('/auth/stripe/inline/cs',{
        //             p:plan,
        //             f:freq
        //         });
        //     }
        // });

        $('.card-details').on('click',function(e){
            e.preventDefault();
            // var plan = $('#plan-type').is(':checked')?'PROFESSIONAL':'CREATOR';
            // var freq = $('#pay-freq').is(':checked')?'yr':'mth';
            // Debug.log('#plan-type is checked? ', $('#plan-type').is(':checked'));
            // Do.Ajax('/auth/stripe/inline/cs',{
            //     p:plan,
            //     f:freq
            // });
        });

        $('.finish-upsell').on('click touchstart',function(e){
            handleAuthCartSubmit(e);
        });

        // var 

    };

    return {
        init:function(){_init()},
        card:function(r){
            $('.card-details').addClass('d-none');
            $('.finish-upsell').removeClass('d-none');
            cartMeta = ecomConf.user.u;
            AuthCartUtils.mountPayElement( r );
        },
    }

}();
